module.exports = __webpack_public_path__ + "static/profile-pic-d16a8b47919ec33e9bf2547d5b511974.png";